import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DateRange } from '@core/services/data.service';
import { Storage } from '@core/utilities/storage';
import { Observable } from 'rxjs';
import { DateRangeSelectorComponent } from './date-range-selector/date-range-selector.component';
import { ModalService } from '@common/services/modal.service';

@Component({
  selector: 'date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})
export class DateRangePickerComponent implements OnInit {

  @Input()
  public force: boolean = false;

  @Input()
  public static: boolean = false;

  @Input()
  public handler: DatePickerHandler;

  private static _active: { name: string, range: DateRange } = null;
  private _active: { name: string, range: DateRange } = null;

  public get active(): { name: string, range: DateRange } {
    return this.static ? DateRangePickerComponent._active : this._active;
  }

  @Input()
  public set active(info: { name: string, range: DateRange }) {

    if (this.static) {
      DateRangePickerComponent._active = info;
    }
    else {
      this._active = info;
    }
  }

  public static get active(): { name: string, range: DateRange } {
    return DateRangePickerComponent._active;
  }

  constructor(private modal: ModalService) {
  }

  ngOnInit() {

    let active = this.active;

    this.active = null;

    if (active) {

      setTimeout(() => {
        this.handler.change(active).subscribe(succeed => {
          if (succeed) this.active = active;
        });
      }, 0);
    }
    else {
      if (this.force) this.open();
    }
  }

  @HostListener('click')
  private open() {
    this.modal.show(DateRangeSelectorComponent, { ignoreBackdropClick: this.force && !this.active, state: { value: this.active ? this.active.range : null } }).content.selected.subscribe(info => {
      if (!this.active || this.active.range.from.getTime() != info.range.from.getTime() || this.active.range.to.getTime() != info.range.to.getTime()) {
        this.handler.change(info).subscribe(succeed => {
          if (succeed) {
            Storage.set("date-range-picker", info);
            this.active = info;
          }
        });
      }
    });
  }
}

export interface DatePickerHandler {
  change: (info: { name: string, range: DateRange }) => Observable<boolean>;
}
